import React, { useRef } from "react";
import DefaultSelect from "components/DefaultSelect";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { TooltipContainer } from "@outplayed/tooltips";

const NHSFilter = ({ options, isDefault, onFilterChange, value, isMobile, disableTooltip }) => {
  const tooltipRef = useRef();
  const { t } = useTranslation();

  if (disableTooltip && disableTooltip.includes("hscombined")) {
    return null;
  }

  const formatOptionLabel = ({ label, img }) => (
    <div className="diff-option">
      <span>{t(label)}</span>
    </div>
  );

  return (
    <TooltipContainer ref={tooltipRef} tooltipInfo={t("Hero & Spec Combined")} disableTooltip={isMobile || disableTooltip}>
      <div>
        <DefaultSelect
          title={t("Hero & Spec Combined")}
          group={"hscombined"}
          isMobile={isMobile}
          className={classNames("filter-select filter-select_diff", isDefault)}
          options={options}
          onChange={(selected) => onFilterChange("hscombined", selected.value)}
          value={value}
          formatOptionLabel={formatOptionLabel}
          isSearchable={false}
          width={150}
        />
      </div>
    </TooltipContainer>
  );
};

export default NHSFilter;
